const i = 'image/'
export default {
  'csv': 'text/csv',
  'gif': i + 'gif',
  'jpg': i + 'jpeg',
  'jpeg': i + 'jpeg',
  'png': i + 'png',
  'pdf': 'application/pdf',
  'svg': i + 'svg+xml'
}
